import ServiceAndMaintenance from './ServiceAndMaintenance/ServiceAndMaintenance';

export async function generateMetadata() {
  return {
    title: 'Service and Maintenance | JAECOO',
    description:
      'Find your location to book a service appointment, then request, plan and visit. Resolve every issue you have in one of our centers all around the UK.',
  };
}

const ServiceAndMaintenancePage = ({ fields }) => {
  return (
    <div className="container">
      <ServiceAndMaintenance fields={fields} />
    </div>
  );
};

export default ServiceAndMaintenancePage;
